import { TextBlockAccountInfo } from 'blocks/TextBlock/Templates'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { AccountInfoSC } from './AccountInfo.styled'

export interface IAccountInfo {
  accountIdTitle?: string
  packageTitle?: string
  subscriptionTitle?: string
  subscription?: string
  subscriberNameTitle?: string
  expirationTimeTitle?: string
  devicesTitle?: string
  webAppVersionTitle?: string
  noraVersionTitle?: string
  eternalIPTitle?: string
  timeZoneTitle?: string
  account?: string
  packages?: string
  subscriber?: string
  expTime?: string
  devices?: string
  webAppVersion?: string
  noraVersion?: string
  extIp?: string
  timezone?: string
  rowGap?: FIXED_INDENTS
}

export const AccountInfo = ({
  accountIdTitle = 'Account ID',
  packageTitle = 'Package',
  subscriberNameTitle = 'Subscriber name',
  expirationTimeTitle = 'Expiration time',
  devicesTitle = 'Devices',
  webAppVersionTitle = 'WebApp version',
  noraVersionTitle = 'Nora version',
  eternalIPTitle = 'External IP',
  timeZoneTitle = 'Timezone',
  account,
  packages,
  subscriber,
  devices,
  expTime,
  extIp,
  timezone,
  noraVersion,
  webAppVersion,
  subscription,
  subscriptionTitle,
  rowGap = FIXED_INDENTS.INDENT_40,
}: IAccountInfo) => {
  return (
    <AccountInfoSC rowGap={rowGap}>
      {account && (
        <TextBlockAccountInfo
          title={accountIdTitle}
          description={account}
          dataTestTitleId='account-id'
        />
      )}
      {packages && (
        <TextBlockAccountInfo
          title={packageTitle}
          description={packages}
          dataTestTitleId='organization'
        />
      )}
      {subscription && (
        <TextBlockAccountInfo
          title={subscriptionTitle}
          description={subscription}
          dataTestTitleId='subscription'
        />
      )}
      {subscriber && (
        <TextBlockAccountInfo
          title={subscriberNameTitle}
          description={subscriber}
          dataTestTitleId='username'
        />
      )}
      {expTime && (
        <TextBlockAccountInfo
          title={expirationTimeTitle}
          description={expTime}
          dataTestTitleId='exp-time'
        />
      )}
      {devices && (
        <TextBlockAccountInfo
          title={devicesTitle}
          description={devices}
          dataTestTitleId='devices'
        />
      )}
      {webAppVersion && (
        <TextBlockAccountInfo
          title={webAppVersionTitle}
          description={webAppVersion}
          dataTestTitleId='app-version'
        />
      )}
      {noraVersion && (
        <TextBlockAccountInfo
          title={noraVersionTitle}
          description={noraVersion}
          dataTestTitleId='mw-version'
        />
      )}
      {extIp && (
        <TextBlockAccountInfo
          title={eternalIPTitle}
          description={extIp}
          dataTestTitleId='ip'
        />
      )}
      {timezone && (
        <TextBlockAccountInfo
          title={timeZoneTitle}
          description={timezone}
          dataTestTitleId='timezone'
        />
      )}
    </AccountInfoSC>
  )
}
